
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"128","height":"128","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('filter',{attrs:{"id":"id-104b","width":"142.4%","height":"142.4%","x":"-21.2%","y":"-15.2%","filterUnits":"objectBoundingBox"}},[_c('feOffset',{attrs:{"dy":"4","in":"SourceAlpha","result":"shadowOffsetOuter1"}}),_c('feGaussianBlur',{attrs:{"in":"shadowOffsetOuter1","result":"shadowBlurOuter1","stdDeviation":"4"}}),_c('feColorMatrix',{attrs:{"in":"shadowBlurOuter1","values":"0 0 0 0 0.508795733 0 0 0 0 0.882755888 0 0 0 0 0.605402107 0 0 0 0.4 0"}})]),_c('path',{attrs:{"id":"id-103a","d":"M63.786 31L97 61h-7v36H39V61h-8l32.786-30z"}})]),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"cx":"64","cy":"64","r":"64","fill":"#C9F6D5"}}),_c('use',{attrs:{"xlink:href":"#id-103a","fill":"#000","filter":"url(#id-104b)"}}),_c('use',{attrs:{"xlink:href":"#id-103a","fill":"#FFF"}}),_c('g',{attrs:{"transform":"translate(65 76)"}},[_c('circle',{attrs:{"cx":"16","cy":"16","r":"16","fill":"#E1312A"}}),_c('path',{attrs:{"fill":"#FFF","d":"M21.657 9.843a1 1 0 010 1.414L17.415 15.5l4.242 4.243a1 1 0 11-1.415 1.415L16 16.914l-4.243 4.243a1 1 0 01-1.414-1.415l4.243-4.242-4.243-4.243a1 1 0 111.414-1.414L16 14.086l4.242-4.243a1 1 0 011.415 0z"}})])])])
          )
        }
      }
    